import { ValidationMessage } from "@/models/validation-message";
import { z } from "zod";
import { getNameAndPhoneSchema } from "./name-and-phone-schema";

export const getCreateErrorReportSchema = () =>
  z.object({
    type: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    address: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    description: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    area: z
      .string()
      .nonempty({ message: ValidationMessage.NON_EMPTY })
      .optional(),
    informer: getNameAndPhoneSchema(),
  });
